import React, {useEffect, useState} from 'react';
import {Link, useHistory, useParams} from "react-router-dom";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import axios from "axios";
import {API_PATH} from "./const";

const CameraConfigSidebar = (props) => {
    const [open, setOpen] = React.useState(false);
    const [open01, setOpen01] = React.useState(false);
    const [open012, setOpen012] = React.useState(false);
    const [open013, setOpen013] = React.useState(false);
    const [open011, setOpen011] = React.useState(false); 
    const [open3, setOpen3] = React.useState(false);
    const [open4, setOpen4] = React.useState(false);
    const [open5, setOpen5] = React.useState(false);
    const [company, setCompany] = useState({})

    let history = useHistory()
    let params = useParams()
    const handleClick = () => {
        setOpen(!open);
        
        setOpen3(false);
        setOpen5(false);
    };

    const handleClicksub1 = () => {
        setOpen01(!open01);
        
        setOpen3(false);
        setOpen5(false);
    };
    const handleClicksub11 = () => {
        setOpen011(!open011);
        
        setOpen3(false);
        setOpen5(false);
    };
    const handleClicksub12 = () => {
        setOpen012(!open012);
        
        setOpen3(false);
        setOpen5(false);
    };
    const handleClicksub13 = () => {
        setOpen013(!open013);
        
        setOpen3(false);
        setOpen5(false);
    };

    const handleClick3 = () => {
        setOpen3(!open3);
        setOpen(false);
        
        setOpen4(false);
        setOpen5(false);
        setOpen01(false);

    };
    const handleClick4 = () => {
        setOpen4(!open4);
        setOpen(false);
        
        setOpen3(false);
        setOpen5(false);
        setOpen01(false);

    };
    const handleClick5 = () => {
        setOpen5(!open5);
        setOpen(false);
        
        setOpen3(false);
        setOpen4(false);
        setOpen01(false);

    };

    const getCompany = () => {
        if (localStorage.getItem("for_com")){
            axios.get(API_PATH + "company/" + localStorage.getItem("for_com"), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setCompany(res.data)
                    localStorage.setItem("name", res?.data?.name)
                    localStorage.setItem("description", res?.data?.description)
                    localStorage.setItem("phone", res?.data?.phone)
                    localStorage.setItem("email", res?.data?.email)
                    localStorage.setItem("id", res?.data?.id)
                    localStorage.setItem("owner_id", res?.data?.owner_id)
                })
        }
    }
    const logout = () => {
        history.push("/login")
        localStorage.clear()
    }
    useEffect(() => {
        getCompany()
    }, [])
    return (
        <div className="main-side-bar">
            <div className="my-side-fix">
                <div className="top-logo">
                    <Link to ="/main/visitor-home">
                        {
                            company ?
                                <img src={(company?.logo?.slice(0, 8) === "https://" || company?.logo?.slice(0, 7) === "http://") ? company?.logo :( "https://" + company?.logo)} alt="..." className="logo-company"/>
                                :
                                <img src="/img/visitorLogo.png" className="logo-company" alt="..."/>
                        }
                    </Link>

                </div>
                <div className="menu-list">
                    <div className="menu-list-item">
                        <List
                            sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={handleClick}>
                                <div className="link-item-style ">
                                    <img src="/icon/ccf1.svg" alt=""/>
                                    <span>System management</span>
                                </div>
                                {open ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                    <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                            </ListItemButton>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                            <ListItemButton onClick={handleClicksub1}>
                                <div className="link-item-style ">
                                    <span>System Configuration</span>
                                </div>
                                {open01 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                    <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                            </ListItemButton>
                            <Collapse in={open01} timeout="auto" unmountOnExit>
                                <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/user-management") ? "link-item-style-active" : ""}>
                                    <Link to={"/main-cameras/user-management/" + params?.id} className="link-item-style ">
                                        <span>User management</span>
                                    </Link>
                                </ListItemButton>
                                <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/system-settings") ? "link-item-style-active" : ""}>
                                    <Link to={"/main-cameras/system-settings/" + params?.id} className="link-item-style ">
                                        <span>System management</span>
                                    </Link>
                                </ListItemButton>
                                <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/equipment-maintenance") ? "link-item-style-active" : ""}>
                                    <Link to={"/main-cameras/equipment-maintenance/" + params?.id} className="link-item-style ">
                                        <span>Equipment Maintenance</span>
                                    </Link>
                                </ListItemButton>

                                <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/system-information") ? "link-item-style-active" : ""}>
                                    <Link to={"/main-cameras/system-information/" + params?.id} className="link-item-style ">
                                        <span>System information</span>
                                    </Link>
                                </ListItemButton>
                            </Collapse>

                                <ListItemButton onClick={handleClicksub11}>
                                    <div className="link-item-style ">
                                        <span>Network Configuration</span>
                                    </div>
                                    {open011 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                        <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                                </ListItemButton>
                                <Collapse in={open011} timeout="auto" unmountOnExit>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/ip-settings") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/ip-settings/" + params?.id} className="link-item-style ">
                                            <span>IP Settings</span>
                                        </Link>
                                    </ListItemButton>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/rtmp") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/rtmp/"  + params?.id} className="link-item-style ">
                                            <span>RTMP</span>
                                        </Link>
                                    </ListItemButton>
                                </Collapse>
                                <ListItemButton onClick={handleClicksub12}>
                                    <div className="link-item-style ">
                                        <span>Face Configuration</span>
                                    </div>
                                    {open012 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                        <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                                </ListItemButton>
                                <Collapse in={open012} timeout="auto" unmountOnExit>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/face-parameters") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/face-parameters/" + params?.id}  className="link-item-style ">
                                            <span>Face Parameters</span>
                                        </Link>
                                    </ListItemButton>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/comparison-parameters") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/comparison-parameters/" + params?.id} className="link-item-style ">
                                            <span>Comparison Parameters</span>
                                        </Link>
                                    </ListItemButton>
                                </Collapse>
                                <ListItemButton onClick={handleClicksub13}>
                                    <div className="link-item-style ">
                                        <span>Audio & Video</span>
                                    </div>
                                    {open013 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                        <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                                </ListItemButton>
                                <Collapse in={open013} timeout="auto" unmountOnExit>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/encoding-parameters") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/encoding-parameters/" + params?.id} className="link-item-style ">
                                            <span>Encoding Parameters</span>
                                        </Link>
                                    </ListItemButton>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/video-parameters") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/video-parameters/" + params?.id}  className="link-item-style ">
                                            <span>Video Parameters</span>
                                        </Link>
                                    </ListItemButton>
                                </Collapse>
                            </Collapse>

                        </List>

                        <List
                            sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={handleClick3}>
                                <div className="link-item-style ">
                                    <img src="/icon/ccf2.svg" alt=""/>
                                    <span>List Library management</span>
                                </div>
                                {open3 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :
                                    <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}
                            </ListItemButton>
                            <Collapse in={open3} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>

                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/face-library-import") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/face-library-import/" + params?.id} className="link-item-style ">
                                            <span>Face Library Import</span>
                                        </Link>
                                    </ListItemButton>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/face-library-export") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/face-library-export/" + params?.id}  className="link-item-style ">
                                            <span>List Library Export</span>
                                        </Link>
                                    </ListItemButton>
                                    <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/user-group-management") ? "link-item-style-active" : ""}>
                                        <Link to={"/main-cameras/user-group-management/" + params?.id}  className="link-item-style ">
                                            <span>User Group Management</span>
                                        </Link>
                                    </ListItemButton>
                                </List>
                            </Collapse>
                        </List>
                        <List
                            sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >

                            <Collapse in={open4} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItemButton sx={{pl: 2}} className={window.location.pathname.startsWith("/main/live") ? "link-item-style-active" : ""}>
                                        <Link to={"/main/live/" + params?.id}  className="link-item-style ">
                                            <img src="/icon/Live2.svg" alt=""/>
                                            <span>Live</span>
                                        </Link>
                                    </ListItemButton>
                                </List>
                            </Collapse>
                        </List>
                        <List
                            sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >

                            <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/real-time-capture") ? "link-item-style-active" : ""}>
                                <Link to={"/main-cameras/real-time-capture/" + params?.id}  className="link-item-style     ">
                                    <img src="/icon/ccf5.svg" alt=""/>
                                    <span>Real-time Capture</span>
                                </Link>
                            </ListItemButton>
                            <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/comparison-record") ? "link-item-style-active" : ""}>
                                <Link to={"/main-cameras/comparison-record/" + params?.id}  className="link-item-style">
                                    <img src="/icon/ccf5.svg" alt=""/>
                                    <span>Comparison Record</span>
                                </Link>
                            </ListItemButton>
                            <ListItemButton sx={{pl: 2}}  className={window.location.pathname.startsWith("/main-cameras/log-record") ? "link-item-style-active" : ""}>
                                <Link to={"/main-cameras/log-record/" + params?.id}  className="link-item-style">
                                    <img src="/icon/ccf5.svg" alt=""/>
                                    <span>Log Record</span>
                                </Link>
                            </ListItemButton>
                        </List>
                    </div>
                    <div className="menu-list-bottom">
                        <div className="left-img-center">
                            <div className="d-flex align-items-center">
                                <Link to="/main/hr-admin/employees/user-profile" className="left-img">
                                    {
                                        localStorage.getItem("image") === "null" ?
                                            <img src="/icon/profileUser.png"/>
                                            :
                                            <img src={localStorage.getItem("image")} alt="Avatar"/>
                                    }
                                </Link>
                                <div className="center-content">
                                    <h5 className="font-family-medium"><Link to="/main/hr-admin/employees/user-profile">  {
                                        localStorage.getItem("first_name") === "null" ?
                                            "User"
                                            :
                                            localStorage.getItem("first_name") + " " + localStorage.getItem("last_name")?.slice(0, 1) + "."
                                    }</Link></h5>
                                    {/*<h6>*/}
                                    {/*    {*/}
                                    {/*        localStorage.getItem("phone_user") === "null" ?*/}
                                    {/*            ""*/}
                                    {/*            :*/}
                                    {/*            localStorage.getItem("phone_user")*/}
                                    {/*    }*/}
                                    {/*</h6>*/}

                                </div>
                            </div>
                            <button onClick={logout}><img src="/icon/logout2.svg" alt="logout"/></button>

                        </div>
                        {/*<div className="right-dot">*/}
                        {/*    <button type="submit"><img src="/icon/verdot.svg" alt="..."/></button>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CameraConfigSidebar;